/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable array-callback-return */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Roboto from '../../../../../assets/fonts/Roboto-Bold.ttf'

import {
  Circle, ClipPath,
  Defs, Document,
  Font, G, Image, Line, Page, Path, Polygon, Rect, StyleSheet, Svg, Text, View
} from '@react-pdf/renderer'
import React, { useEffect, useState } from 'react'
import { AssessmentReportResponse, AssessmentResponse, iCorTabela, iLinhaTabela, iResponsavelPDL } from '../..'
import { iColaboradorBase, iCompetencia, iCompetenciaPDI, iEscala, iGrafico, iPerfilPi } from '../../../../../interfaces'
import { ArrayToChunks, PropInvalida } from '../../../../../Utils/Helper'
import { iAcao } from '../Recomendacoes'
import { iMediaAbsoluta } from '../Tabela'
import Aderencia from './assets/Aderencia.png'
import Agenda1 from './assets/agenda1.jpg'
import ArcoAlvo from './assets/ArcoAlvo.png'
import Arquitetura from './assets/Arquitetura.png'
import AssessmentCognitivo from './assets/AssessmentCognitivo.png'
import AutoAval from './assets/AutoAval.png'
import BarraLateralAgenda from './assets/BarraLateralAgenda.png'
import BarraLateralCapa from './assets/BarraLateralCapa.png'
import coluna1 from './assets/coluna1.png'
import coluna2 from './assets/coluna2.png'
import Conceito from './assets/Conceito.png'
import Contato from './assets/Contato.jpg'
import ContornoLateralRoxo from './assets/ContornoLateralRoxo.png'
import Engrenagem from './assets/Engrenagem.png'
import FundoRoxo from './assets/fundoRoxo.png'
import Gestor from './assets/Gestor.png'
import Gradient from './assets/gradient_a4_landscape.jpg'
import Grupo from './assets/grupo.png'
import Individuo from './assets/Individuo.png'
import LearningModel from './assets/LearningModel.png'
import LicaoDeCasa from './assets/LicaoDeCasa.jpg'
import Liderados from './assets/Liderados.png'
import Logo2AH from './assets/Logo2AH.png'
import LogoAHRodape from './assets/LogoAH-Rodape.jpg'
import LogoAH from './assets/LogoAH.png'
import Nota1 from './assets/Nota1.png'
import Nota2 from './assets/Nota2.png'
import Nota3 from './assets/Nota3.png'
import Nota4 from './assets/Nota4.png'
import Outros from './assets/Outros.png'
import Pares from './assets/Pares.png'
import Persona from './assets/Persona.png'
import Resultados from './assets/Resultados.png'
import TextoFundoRoxo from './assets/TextoFundoRoxo.png'

// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-interface
interface iModel {
  avaliado: iColaboradorBase
  nomeEmpresa: string
  classificacaoCognitivo: number
  escala: iEscala
  eixos: number[]
  competencias: iCompetencia[]
  grafico1: string
  grafico2: string
  tabela: iLinhaTabela[]
  graficoHierarquia: iGrafico
  cores: iCorTabela[]
  comentarios: string[]
  imagensQuadro: Array<{ base64: string, id: string }>
  logoEmpresa: string
  tipoPesquisa: string
  recomendacoes: iCompetenciaPDI[]
  perfilPI: iPerfilPi
  mediaGeral: string
  acoes: iAcao[]
  cognitivo?: number
  combinado: AssessmentResponse
  responsavel: iResponsavelPDL
  relatorioPi: AssessmentReportResponse
}

export const RelatorioPDFPDL: React.FC<iModel> = ({ avaliado, classificacaoCognitivo, comentarios, competencias, eixos, escala, grafico1, grafico2, nomeEmpresa, tabela, logoEmpresa, imagensQuadro, tipoPesquisa, graficoHierarquia, cores, recomendacoes, perfilPI, mediaGeral, acoes, cognitivo, combinado, responsavel, relatorioPi }) => {
  const [Is90Graus, setIs90Graus] = useState(false)
  Font.register({
    family: 'Roboto',
    fonts: [{
      src: Roboto
    }]
  })

  const urlDefault = 'https://sigah.blob.core.windows.net/assets/icones/Icones-SISTEMA-01.png'

  const selos: any[] = [
    { Nome: 'Guardião', Definicao: 'Um Guardião é altruísta e colaborativo, com preferência por trabalho detalhado baseado em habilidades.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/GuardianBadge.en-US.png' },
    { Nome: 'Individualista', Definicao: 'Um Individualista é altamente independente e persistente, orientado por resultados.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/IndividualistBadge.en-US.png' },
    { Nome: 'Operador', Definicao: 'Um Operador é um membro da equipe paciente, consciencioso, descontraído e cooperativo.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/OperatorBadge.en-US.png' },
    { Nome: 'Persuasivo', Definicao: 'Um Persuasivo constrói equipes, assume riscos, é aquele que persuade, é socialmente equilibrado e motivador.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/PersuaderBadge.en-US.png' },
    { Nome: 'Promotor', Definicao: 'Um Promotor é extrovertido, casual, desinibido e persuasivo, com tendência à informalidade.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/PromoterBadge.en-US.png' },
    { Nome: 'Adaptativo', Definicao: 'Um Adaptativo é um construtor de pontes, confortável com situações em mudança.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/AdapterBadge.en-US.png' },
    { Nome: 'Altruísta', Definicao: 'Um Altruísta é agradável e cooperativo, com uma ética de trabalho eficiente e precisa.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/AltruistBadge.en-US.png' },
    { Nome: 'Artesão', Definicao: 'Um Artesão é complacente e analítico, enquanto produz um trabalho altamente preciso e meticuloso.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/CraftsmanBadge.en-US.png' },
    { Nome: 'Aventureiro', Definicao: 'Um Aventureiro é um pensador inovador e individualista, criativo, que não é intimidado pelo fracasso.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/MaverickBadge.en-US.png' },
    { Nome: 'Capitão', Definicao: 'Um Capitão é um solucionador de problemas que gosta de mudanças e inovações, enquanto controla o quadro geral.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/CaptainBadge.en-US.png' },
    { Nome: 'Colaborador', Definicao: 'Um Colaborador é um membro da equipe amigável, compreensivo, receptivo e paciente.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/CollaboratorBadge.en-US.png' },
    { Nome: 'Controlador', Definicao: 'Um Controlador é orientado por detalhes e conservador, com preferência por alta qualidade e conhecimento técnico.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/ControllerBadge.en-US.png' },
    { Nome: 'Crítico-Analítico', Definicao: 'Um Crítico-Analítico é intenso, com altos padrões de exigência e uma personalidade disciplinada e reservada.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/AnalyzerBadge.en-US.png' },
    { Nome: 'Empreendedor', Definicao: 'Um Empreendedor é alguém que tem iniciativa, assume riscos, é motivado e orientado por objetivos.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/VenturerBadge.en-US.png' },
    { Nome: 'Especialista', Definicao: 'Um Especialista é um trabalhador altamente preciso, frequentemente cético e respeita a autoridade.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/SpecialistBadge.en-US.png' },
    { Nome: 'Estrategista', Definicao: 'Um Estrategista é orientado por resultados, inovador, analítico e tem um impulso para a mudança.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/StrategistBadge.en-US.png' },
    { Nome: 'Estudioso', Definicao: 'Um Estudioso é preciso, reservado, imaginativo e busca um alto nível de conhecimento técnico.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/ScholarBadge.en-US.png' }
  ]

  function getSeloInfoByNome(nomeSelo: string): { url: string, definicao: string } {
    const seloEncontrado = selos.find(selo => selo.Nome.toLowerCase() === nomeSelo.toLowerCase())
    if (!seloEncontrado) return { url: '', definicao: '' }

    return {
      url: seloEncontrado.UrlAvatar,
      definicao: seloEncontrado.Definicao
    }
  }

  function GraficoSelf(fatorA: number, fatorB: number, fatorC: number, fatorD: number, width: number, fatorE?: number): any {
    const norma = 238
    const amplitudeGrafico = 79

    // Converter os valores (-3 a 3) para posições no SVG
    const fatorAx = norma + fatorA * amplitudeGrafico
    const fatorBx = norma + fatorB * amplitudeGrafico
    const fatorCx = norma + fatorC * amplitudeGrafico
    const fatorDx = norma + fatorD * amplitudeGrafico
    const fatorEx = fatorE ? (norma + fatorE * amplitudeGrafico) : null

    return (
      <Svg
        width={width}
        height={width * ((fatorEx ? 126 : 106) / 478)}
        viewBox={`0 0 478 ${fatorEx ? 126 : 106}`}
        fill="none"
      >
        <G clipPath="url(#clip0_1_2)">
          <Path d={`M476.92 0.5H0.5V${(fatorEx ? 125 : 105)}H476.92V0.5Z`} fill="white" />
          <Path d={`M476.42 1V${(fatorEx ? 125 : 105)}H1V1H476.42ZM477.42 0H0V${(fatorEx ? 125 : 105)}H477.42V0Z`} fill="#C9CBCC" />
          <Path d={`M238.71 ${(fatorEx ? 111 : 91)}L246.71 ${(fatorEx ? 125 : 105)}H230.71L238.71 ${(fatorEx ? 111 : 91)}Z`} fill="black" />
          <Path d={`M477.42 ${(fatorEx ? 119 : 99)}H0V${(fatorEx ? 125 : 105)}H477.42V99.77Z`} fill="#3189C0" />
          <Path d={`M238.71 381.14V${(fatorEx ? 104 : 84)}`} stroke="#C9CBCC" strokeWidth="0.617401"/>

          {/* Círculos */}
          <Circle cx={fatorAx} cy={21.154} r={6.49} fill="#000000" />
          <Circle cx={fatorBx} cy={42.308} r={6.49} fill="#000000" />
          <Circle cx={fatorCx} cy={63.462} r={6.49} fill="#000000" />
          <Circle cx={fatorDx} cy={84.616} r={6.49} fill="#000000" />
          {fatorEx && <Circle cx={fatorEx} cy={105.77} r={6.49} fill="#000000" />}

          <Line x1={fatorAx} y1={21.154} x2={fatorBx} y2={42.308} stroke="#252525" strokeWidth="2"/>
          <Line x1={fatorBx} y1={42.308} x2={fatorCx} y2={63.462} stroke="#252525" strokeWidth="2"/>
          <Line x1={fatorCx} y1={63.462} x2={fatorDx} y2={84.616} stroke="#252525" strokeWidth="2"/>
          {fatorEx && <Line x1={fatorDx} y1={84.616} x2={fatorEx} y2={105.77} stroke="#252525" strokeWidth="2"/>}
        </G>
        <Defs>
          <ClipPath id="clip0_1_2">
            <Rect width="477.42" height={fatorEx ? 126 : 106} fill="white" />
          </ClipPath>
        </Defs>
      </Svg>
    )
  }

  function returnCombinado(): any {
    return <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: 384, backgroundColor: '#ffffff', width: 310, gap: 22 }}>
      <View style={{ height: 90, width: 290, display: 'flex', flexDirection: 'column', gap: 8, marginTop: 18 }}>
        <Text style={{ fontSize: 16, fontFamily: 'Roboto', fontWeight: 'bold', color: '#1961E0' }}>Self</Text>
        {GraficoSelf(combinado.selfSigmaScores?.aSigma, combinado.selfSigmaScores?.bSigma, combinado.selfSigmaScores?.cSigma, combinado.selfSigmaScores?.dSigma, 290)}
      </View>
      <View style={{ height: 90, width: 290, display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Text style={{ fontSize: 16, fontFamily: 'Roboto', fontWeight: 'bold', color: '#1961E0' }}>Conceito do Self</Text>
        {GraficoSelf(combinado.selfConceptSigmaScores?.aSigma, combinado.selfConceptSigmaScores?.bSigma, combinado.selfConceptSigmaScores?.cSigma, combinado.selfConceptSigmaScores?.dSigma, 290)}
      </View>
      <View style={{ height: 112, width: 290, display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Text style={{ fontSize: 16, fontFamily: 'Roboto', fontWeight: 'bold', color: '#1961E0' }}>Síntese</Text>
        {/* {GraficoSelf(combinado.synthesisSigmaScores?.aSigma, combinado.synthesisSigmaScores?.bSigma, combinado.synthesisSigmaScores?.cSigma, combinado.synthesisSigmaScores?.dSigma, 290, combinado.synthesisSigmaScores?.eSigma)} */}
        {GraficoSelf(combinado.synthesisSigmaScores?.aSigma, combinado.synthesisSigmaScores?.bSigma, combinado.synthesisSigmaScores?.cSigma, combinado.synthesisSigmaScores?.dSigma, 290)}
      </View>
    </View>
  }

  const styles = StyleSheet.create({
    DefaultPage: {
      paddingVertical: 16,
      paddingHorizontal: 32,
      flexDirection: 'column',
      justifyContent: 'space-between'
    },
    Title: {
      fontSize: '52px',
      fontFamily: 'Roboto',
      fontWeight: 'bold',
      color: '#fff'
    },
    TitleBlue: {
      fontSize: '15px',
      fontFamily: 'Roboto',
      fontWeight: 'bold',
      color: '#1961E0'
    },
    leftColumn: {
      width: 740,
      padding: 24,
      paddingLeft: 32,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      gap: 12,
      zIndex: -1
    },
    title: {
      fontSize: 42,
      color: '#66046B',
      fontWeight: 'bold',
      marginBottom: 8
    },
    card: {
      paddingLeft: 9,
      paddingVertical: 14,
      borderRadius: 4,
      fontSize: 20
    },
    activeCard: {
      backgroundColor: '#66046B',
      color: '#fff'
    },
    inactiveCard: {
      backgroundColor: '#e0e0e0',
      color: '#66046B'
    },
    rightImage: {
      height: 450
    },
    table: {
      display: 'flex',
      width: 'auto',
      borderStyle: 'solid',
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0
    },
    tableRow: {
      margin: 'auto',
      flexDirection: 'row'
    },
    tableCol: {
      width: `${(100 / (cores.length + (!Is90Graus ? 1 : 0)))}%`,
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      fontFamily: 'Roboto',
      fontWeight: 'bold'
    },
    tableHeaderCol: {
      width: `${(100 / (cores.length + (!Is90Graus ? 1 : 0)))}%`,
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      fontFamily: 'Roboto',
      fontWeight: 'bold',
      color: 'white',
      backgroundColor: '#66046B'
    },
    tableCell: {
      margin: 'auto',
      fontSize: 10,
      padding: 5,
      fontFamily: 'Roboto',
      fontWeight: 'bold'
    },
    tableCellCompetencia: {
      fontSize: 10,
      padding: 5,
      fontFamily: 'Roboto',
      fontWeight: 'bold',
      backgroundColor: '#66046B32'
    },
    tableCellQuestao: {
      fontSize: 10,
      padding: 5,
      fontFamily: 'Roboto',
      fontWeight: 'bold',
      backgroundColor: '#66046B15'
    }
  })

  Font.registerHyphenationCallback((e) => {
    if (e.includes('http') && e.length > 100) {
      const arr: string[] = []
      for (let i = 0; i < e.length; i += 100) {
        arr.push(e.substring(i, i + 100))
      }
      return arr
    }

    if (e.includes('Flexibilidade/Adaptabilidade')) {
      return e.split('/')
    }

    if (e.includes('Autodesenvolvimento')) {
      return ['Autodesenvolvi', 'mento']
    }

    if (e.length === 1) {
      return [e, '']
    }
    return [e]
  })

  function ObterIcone2(selo: number): any {
    if (selo === 4) {
      return (
     <Svg viewBox="0 0 500 500" style={{ width: 16, height: 16 }} ><Path fill="#fff" d="M421.08,39.84c12.77,0,25.54.1,38.31-.08,2.74,0,3.27.54,3.27,3.27q-.12,190.94-.07,381.88c0,7.45-.07,14.9.05,22.34,0,1.72-.33,2.36-2.05,2a7.75,7.75,0,0,0-1.6,0q-201.12,0-402.26.08c-3,0-3.67-.68-3.67-3.67q.13-201.12,0-402.23c0-3,.67-3.72,3.67-3.67,12.37.19,24.74.08,37.11.08a11.62,11.62,0,0,1,3.32,2.78c27.11,34.8,54.42,69.44,81.57,104.2,1.06,1.36,2.38,2.61,1.74,4.61-3.66,3.67-4.27,8.17-4.22,13.17.2,18.22,0,36.44.12,54.65a10.48,10.48,0,0,1-3.85,8.71c-10.88,9.25-19.14,20.58-26,33a118.78,118.78,0,0,0-14.59,46.91c-2.61,28,2.81,54.44,17.68,78.67a125.12,125.12,0,0,0,97.7,60.24,121.69,121.69,0,0,0,57-8.57c35.24-14.47,59.39-39.83,72.34-75.72a120,120,0,0,0,6.76-35.87c1.38-32-8.21-60.21-28-85.1-3.87-4.87-7.76-9.82-12.9-13.53-2.93-2.12-4-5-3.95-8.64.1-18.35-.07-36.71.13-55.05.05-4.89-.69-9.21-4.19-12.78-.66-1.79.38-3,1.38-4.3,24.32-30.95,48.51-62,72.88-92.9,2.88-3.65,5.79-7.29,8.54-11A11,11,0,0,1,421.08,39.84Z"/><Path fill="#e62f41" d="M421.08,39.84Q388.92,81,356.77,122.11q-11.16,14.29-22.24,28.65c-2.68,1.19-5.15-.55-7.78-.53-7.16.06-14.32,0-21.86,0,3.85,5.4,8,10.2,11.68,15.3,1,1.32,2.61,2.49,1.5,4.54a4.74,4.74,0,0,1-3.36.94c-11.51,0-23,.26-34.52-.15a4.66,4.66,0,0,1-1.84-.77c-6.79-7.13-12.47-15.18-18.53-22.92Q220,96.32,180.14,45.44c-1.31-1.67-3.53-3-3.29-5.6h40.71c6.59,6.94,12.08,14.78,18,22.26q11.25,14.19,22.35,28.52c6.55,8.57,13.13,17.12,20,25.44,6.09,8.23,12.71,16,18.78,24.28,1.67,2.26,2.87,2.47,4.77,0Q322.09,114,342.77,87.61q17.46-22.29,35-44.55a10.87,10.87,0,0,1,3.46-3.22Z"/><Path fill="#ebeae5" d="M176.85,39.84,278.24,169.18c-.35,2.06-2.07,1.71-3.39,1.79-2.62.17-5.24.06-7.86.08-10.12-.11-20.24.17-30.35-.13-2-.29-3.12-1.83-4.27-3.31q-30.1-38.43-60.23-76.84C159.91,75.2,147.77,59.57,135.53,44c-.94-1.2-2.29-2.32-1.78-4.18Z" /> <Path fill="#e62f41" d="M133.75,39.84q18.83,24.21,37.67,48.41,31.91,40.82,63.87,81.58a1.13,1.13,0,0,1-.47,1.32,5.68,5.68,0,0,1-3.06.75c-11.41,0-22.83.34-34.23-.17a4.84,4.84,0,0,1-3-1.74q-6.87-8.36-13.34-17a3.6,3.6,0,0,1-.79-2.19Q160.69,125.48,141,100.16,117.42,70,93.84,39.84Z" /> <Path fill="#ebeae5" d="M381.18,39.84q-20,25.75-40.09,51.5c-13.07,16.73-26.25,33.37-39.24,50.17-2,2.58-3,3.28-5.23.22-6.22-8.43-12.74-16.62-19.15-24.9-.1-1.65,1.07-2.69,1.94-3.81q27.7-35.31,55.35-70.64a28.77,28.77,0,0,1,2.52-2.54Z" />      <Path fill="#e62f41" d="M337.28,39.84a4.38,4.38,0,0,1-.44,1.42q-29.67,37.8-59.37,75.57c-6.86-8.36-14-16.53-19.78-25.69,0-1.92,1.34-3.12,2.39-4.44,11.43-14.4,22.65-29,34.08-43.37a25.9,25.9,0,0,1,3.21-3.49Z" />
      <Path fill="#fff" d="M297.37,39.84c-1,3.23-3.59,5.41-5.58,8-11.31,14.48-22.72,28.9-34.1,43.34-5.54-5.49-9.84-12-14.67-18.08C235,62.93,227,52.7,219,42.5c-.62-.8-1.65-1.41-1.46-2.66Z" />
      <Path fill="#f8ac32" d="M180.41,150.78l15.73,19.88c1.22,1.63,1,3.54,1,5.38,0,9,0,18.08,0,27.12,0,3.77.53,4.09,3.88,2.46a128.26,128.26,0,0,1,64.6-12.79A126.57,126.57,0,0,1,311,204.23c.85.39,1.66.84,2.5,1.24,3.81,1.79,4.19,1.56,4.23-2.76.08-10.37-.13-20.73.1-31.1,0-.82.75-1.59.18-2.45l-15.4-19.9c11.25.94,21.64-1.32,31.88,1.5,4,2.92,5.35,6.78,5.3,11.73-.19,19.28,0,38.56-.12,57.85a6.91,6.91,0,0,0,2.44,5.85c20.55,18.21,34,40.81,39.61,67.59,7.68,36.53,1,70.53-20.71,101.11-19.05,26.82-45,43.73-77.09,50.66a122.83,122.83,0,0,1-78.66-8.41c-34.21-15.65-57.23-41.67-69.09-77.31-6.31-18.94-7.55-38.46-4.51-58.22C135.8,274.9,147.53,252,166,232.42a12.29,12.29,0,0,1,2.25-2.25c6-3.7,7.26-9,7.06-15.81-.51-17.41-.06-34.85-.24-52.27C175.05,157.27,176.57,153.58,180.41,150.78Z" />
      <Path fill="#706c74" d="M318.05,169.16a1.4,1.4,0,0,1,.73,1.54,4.72,4.72,0,0,1-3.66,1.23q-16.28.15-32.55,0a6.23,6.23,0,0,1-3.08-.68.83.83,0,0,1-.36-1.28c11.61,0,23.22,0,34.83-.07C315.33,169.89,316.89,170.5,318.05,169.16Z" /> <Path fill="#aeadae" d="M279.13,170a1.68,1.68,0,0,0,0,.63c-3.74,2.31-7.67,1.4-11.59.66A1,1,0,0,1,267,170c3.72-.57,7.59.79,11.23-.83Z" />
      <Path fill="#e5aea2" d="M267,170v.6c-1.18,1.39-2.84,1.34-4.41,1.36q-11.58.12-23.15,0c-1.58,0-3.23,0-4.43-1.32l.27-.82Z" />
      <Path fill="#fff" d="M235,170.65l32,0h12.08l39.69.1v38.47q-61.23-30.87-122.64,0V170.66Z" />
      <Path fill="#dd8e1a" d="M352.46,321.33a94.56,94.56,0,0,1-95,95c-52.85,0-95.17-42.62-95.19-95.77,0-51.47,42.81-95.53,96.51-94.84C310,226.42,353.42,268.87,352.46,321.33Z" />
      <Path fill="#f8ac32" d="M251.3,279.54c-1.73,2.07-3.32,3.92-4.86,5.83C244.3,288,242,290,238.32,288c-2.75-1.49-4.7-6.4-3.62-9.37a12.67,12.67,0,0,1,3.19-5c6.27-5.93,12.43-12,18.75-17.85,2.39-2.22,5.08-3.53,8.7-2.32,4,1.34,5.76,3.67,5.73,7.91-.1,17.68,0,35.37,0,53.06,0,21.27-.28,42.55.16,63.82.14,7.06-5.79,9.6-10.69,9-7.89-1-8.76-2.46-8.72-9.76.16-31.12.08-62.24.05-93.36C251.83,282.77,252.22,281.31,251.3,279.54Z" />
    </Svg>)

      //  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      //   <Path d="M0.500178 0H4.50008C4.6657 0 4.82195 0.084375 4.9157 0.221875L7.45001 4.02187C5.90318 4.15 4.51258 4.82187 3.46261 5.84375L0.0845632 0.778125C-0.0185593 0.625 -0.0279341 0.428125 0.0595638 0.265625C0.147062 0.103125 0.315808 0 0.500178 0ZM15.9154 0.778125L12.5374 5.84688C11.4905 4.825 10.0968 4.15313 8.54999 4.025L11.0843 0.221875C11.178 0.08125 11.3343 0 11.4999 0H15.4998C15.6842 0 15.8529 0.1 15.9404 0.265625C16.0279 0.43125 16.0186 0.625 15.9154 0.778125ZM13.4999 10.5C13.4999 13.5375 11.0374 16 8 16C4.96257 16 2.50013 13.5375 2.50013 10.5C2.50013 7.4625 4.96257 5 8 5C11.0374 5 13.4999 7.4625 13.4999 10.5ZM8.26249 7.53438C8.15625 7.31563 7.84688 7.31563 7.73751 7.53438L7.03752 8.95312C6.99377 9.04062 6.91253 9.1 6.81878 9.1125L5.25007 9.34062C5.00945 9.375 4.9157 9.66875 5.08757 9.84062L6.22192 10.9469C6.29067 11.0156 6.32192 11.1094 6.30629 11.2063L6.03755 12.7656C5.99692 13.0031 6.24692 13.1875 6.46254 13.075L7.8625 12.3375C7.94688 12.2937 8.05 12.2937 8.13437 12.3375L9.53434 13.075C9.74996 13.1875 9.99995 13.0062 9.95933 12.7656L9.69059 11.2063C9.67496 11.1125 9.70621 11.0156 9.77496 10.9469L10.9093 9.84062C11.0843 9.67187 10.9874 9.37812 10.7468 9.34062L9.18122 9.1125C9.08747 9.1 9.0031 9.0375 8.96248 8.95312L8.26249 7.53438Z" fill="#27AE60"/>
      // </Svg>
    } else {
      return (<Svg viewBox="0 0 500 500" style={{ width: 16, height: 16 }} >
        <Path fill="#fff" d="M250.08,436.47q-94.46,0-188.9.08c-2.88,0-3.17-.81-3.17-3.33q.09-188.69,0-377.37c0-2.63.44-3.3,3.22-3.29q188.7.13,377.41,0c3,0,3.37.82,3.37,3.51q-.11,188.51,0,377c0,2.74-.53,3.48-3.4,3.47Q344.34,436.39,250.08,436.47Z" />      <Path fill="#2d2f6c" d="M250.17,430.5H105.41c-13.2,0-20.37-7.15-20.38-20.3,0-5.75,0-11.49,0-17.24.07-10.37,6.74-17.77,17-18.65,2.06-.18,2.29-1,2.55-2.71q5.48-35.5,11.07-71Q123,254,130.22,207.43c2.86-18.36,5.67-36.73,8.67-55.08a41.23,41.23,0,0,1,38.56-34.65c1.74-.1,3.49-.19,5.23-.19q67.71,0,135.41,0c20.3,0,35.64,10.14,41.91,27.64,2.42,6.75,2.94,13.89,4.05,20.9q7.81,49.53,15.48,99.09,7.65,49.19,15.28,98.36c.1.62.22,1.23.28,1.85.48,5.25,1.1,9.29,8.33,10.11s12.05,8.63,12.24,16c.18,7.25.22,14.5,0,21.74-.32,10-8.35,17.25-18.85,17.26Q323.48,430.52,250.17,430.5Z" />      <Path fill="#2e306c" d="M121.57,106.36a3.63,3.63,0,0,1-4.64,3.46,5.4,5.4,0,0,1-1.9-1.12Q93.21,89.11,71.43,69.45c-2.27-2-1.87-5.14.56-6.17a4,4,0,0,1,4.47.92l43.36,39A4.74,4.74,0,0,1,121.57,106.36Z" />      <Path fill="#2e306c" d="M430.78,66.64c.13,1.4-.87,2.37-1.9,3.29q-21.39,19.25-42.79,38.48c-1.91,1.72-3.95,2.47-5.88.39s-1-4.08.94-5.79q21.41-19.23,42.78-38.5c1.4-1.26,2.9-2,4.73-1.27A3.35,3.35,0,0,1,430.78,66.64Z" />      <Path fill="#2e306c" d="M157.57,82.22c.12,2,.3,4,.36,6,.06,2.42-.87,4.21-3.56,4.27-2.45,0-3.53-1.47-3.65-3.79Q150,76,149.32,63.31c-.15-2.58.61-4.59,3.51-4.64s3.7,2.08,3.83,4.53c.34,6.34.64,12.68,1,19Z" />      <Path fill="#2e306c" d="M350.73,77.34c-.15,2.53-.44,6.87-.69,11.22-.14,2.51-1.3,4-3.94,3.87-2.48-.17-3.39-1.91-3.29-4.15q.58-12.68,1.3-25.35c.15-2.51,1.19-4.48,4.07-4.25,2.66.21,3.39,2.12,3.26,4.53C351.21,67.31,351,71.41,350.73,77.34Z" />      <Path fill="#2e306c" d="M90.47,149.59c-4,0-7.94,0-11.91,0-2.48,0-4.22-.92-4.27-3.56,0-2.41,1.51-3.53,3.83-3.65Q91,141.7,103.79,141c2.33-.12,4,.83,4.26,3.18.28,2.62-1.43,3.9-3.82,4.07-4.59.32-9.18.49-13.77.72Z" /> <Path fill="#2e306c" d="M409.91,148.92c-4.22-.19-8.44-.35-12.65-.58-2.44-.13-4.65-.93-4.57-3.8.08-3.07,2.33-3.68,5-3.52,8.18.49,16.37.92,24.55,1.34,2.61.13,4.42,1.18,4.16,4-.24,2.71-2.24,3.28-4.6,3.17-4-.19-7.94-.35-11.91-.53Z" />   <Path fill="#eb5867" d="M197.18,124.9c1-.06,2-.17,3-.17q59.46,0,118.93,0c18.87,0,32.33,11.13,35.75,29.61,1.85,10.05,3.19,20.2,4.76,30.3q5.47,35.1,10.94,70.2,6.16,39.54,12.28,79.09c1.6,10.34,3.08,20.7,4.61,31.06.67,2-.68,2.4-2.09,2.72a20.27,20.27,0,0,1-4.47.24q-115.65,0-231.29,0a15.7,15.7,0,0,1-5.54-.52c-2.42-1.6-1.67-4-1.33-6.11,3-18.75,5.88-37.51,8.8-56.27,7.69-49.48,15.5-98.94,23.1-148.44,1.81-11.84,6.45-22,16.47-29.12A12.5,12.5,0,0,1,197.18,124.9Z" />      <Path fill="#5a64a0" d="M102.84,381.63c5.79-1.19,11.64-.54,17.45-.35,1.95.07,3.95.36,5.93.36H393.35c1.49,0,3,0,4.49,0,6.1.16,10.32,4.26,10.43,10.36.12,6.37.05,12.74,0,19.11,0,8-3.94,11.91-11.93,11.91q-130.38,0-260.76,0c-9.83,0-19.67.37-29.5.53-1.33,0-2.76.38-4-.56.9-1.09,2.19-1.15,3.42-1.14,4.56,0,9.15-.41,13,.27-6.19-5.93-6.18-33.31.29-40-2.86,1.34-6.31.54-9.64.61C107.07,382.86,104.7,383.46,102.84,381.63Z" />      <Path fill="#ef7885" d="M197.18,124.9c-13.46,7.14-20,18.62-21.73,33.52-1.39,11.68-3.61,23.26-5.41,34.9-1.94,12.49-3.79,25-5.75,37.47-1.83,11.63-3.79,23.24-5.6,34.87-1.92,12.24-3.7,24.51-5.61,36.75-1.84,11.76-3.93,23.47-5.58,35.25-1.36,9.69-3.54,19.27-4.16,29.07a2.76,2.76,0,0,1-1.21.81c-8.63.81-17.26.35-25.89.25-2,0-3.86-.61-2.85-3.39,1.85-12.44,3.66-24.9,5.58-37.34q6.15-39.72,12.4-79.44,6.6-42.3,13.23-84.6c.65-4.19,1.1-8.43,2.15-12.52,3.79-14.7,16-24.61,31.75-25.62C184.7,124.49,191,124.87,197.18,124.9Z" />      <Path fill="#dd4f5d" d="M142.66,366.79l.68-.06q120.1,0,240.22,0c1.47,0,3.42.73,3.87-1.73,2.59,9.21,2.59,9.21-6.5,9.21H146.73c-1.62,0-3.24-.09-4.86-.13C140.46,371.47,141.36,369.11,142.66,366.79Z" /><Path fill="#7b83b4" d="M102.84,381.63h17c-5.78,9.65-5.78,32.05,0,41.42H102.13c-6.08-.85-9.59-4.65-9.68-10.77-.1-6.6-.1-13.22,0-19.82C92.54,386,96.38,382.13,102.84,381.63Z" />      <Path fill="#df6c79" d="M142.66,366.79q-.41,3.65-.79,7.29c-9.19,0-18.37,0-27.56.17-2,0-2.73-.6-2.32-2.58.5-2.41.93-4.84,1.4-7.27-.11,2.41,1.49,2.37,3.22,2.37C125.29,366.75,134,366.78,142.66,366.79Z" /></Svg>)
    }
  }

  function ReturnSeta(color: string): any {
    return <Svg id="Layer_1" fill={color}
      viewBox="0 0 100 100" width={130} height={68}>
    <Path d="M2.9,51.6h87.6l-7.7,7.6c-1,1-1,2.6,0,3.5l0,0c1,1,2.6,1,3.5,0l12.9-13c0.4-0.4,0.4-1,0-1.4l-12.9-13c-1-1-2.6-1-3.5,0l0,0
      c-1,1-1,2.6,0,3.5l7.7,7.6H2.9c-1.4,0-2.5,1.1-2.5,2.5l0,0C0.4,50.5,1.5,51.6,2.9,51.6z"/>
    </Svg>
  }

  function ReturnCheck(color: string): any {
    return <Svg viewBox="0 0 32 32" fill={color} height="18px" width="18px"><G data-name="24-Check"><Path d="M25 0H7a7 7 0 0 0-7 7v18a7 7 0 0 0 7 7h18a7 7 0 0 0 7-7V7a7 7 0 0 0-7-7zm5 25a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5h18a5 5 0 0 1 5 5z"/><Path d="m13 21.59-4.29-4.3-1.42 1.42 5 5a1 1 0 0 0 1.41 0l13-13-1.41-1.42z"/></G></Svg>
  }

  function ReturnX(color: string): any {
    return <Svg fill={color} height="18px" width="18px"id="Layer_1" viewBox="0 0 485 485">
      <G>
        <Path d="M0,0v485h485V0H0z M455,455H30V30h425V455z"/>
        <Polygon points="160.026,346.186 242.5,263.713 324.974,346.186 346.187,324.973 263.713,242.5 346.187,160.027 324.974,138.814 242.5,221.287 160.026,138.814 138.813,160.027 221.287,242.5 138.813,324.973"/>
      </G>
    </Svg>
  }

  function handleMedia(): iMediaAbsoluta[] {
    const medias = {
      mediaAltaLideranca: 0,
      mediaPares: 0,
      mediaAutoAval: 0,
      mediaGestor: 0,
      mediaLiderados: 0,
      mediaOutros: 0,
      mediaConsolidado: 0,
      mediaSemAuto: 0
    }
    tabela.forEach((e): void => {
      const parse = parseFloat(e.pares?.replace(',', '.') ?? '')
      medias.mediaPares = medias.mediaPares + (isNaN(parse) ? 0 : parse)
    })
    tabela.forEach((e): void => {
      const parse = parseFloat(e.autoAvaliacao?.replace(',', '.') ?? '')
      medias.mediaAutoAval = medias.mediaAutoAval + (isNaN(parse) ? 0 : parse)
    })
    tabela.forEach((e): void => {
      const parse = parseFloat(e.gestor?.replace(',', '.') ?? '')
      medias.mediaGestor = medias.mediaGestor + (isNaN(parse) ? 0 : parse)
    })
    tabela.forEach((e): void => {
      const parse = parseFloat(e.liderados?.replace(',', '.') ?? '')
      medias.mediaLiderados = medias.mediaLiderados + (isNaN(parse) ? 0 : parse)
    })
    tabela.forEach((e): void => {
      const parse = parseFloat(e.mediaSemAuto.replace(',', '.') ?? '')
      medias.mediaSemAuto = medias.mediaSemAuto + (isNaN(parse) ? 0 : parse)
    })
    tabela.forEach((e): void => {
      const parse = parseFloat(e.outros?.replace(',', '.') ?? '')
      medias.mediaOutros = medias.mediaOutros + (isNaN(parse) ? 0 : parse)
    })
    tabela.forEach((e): void => {
      const parse = parseFloat(e.altalideranca?.replace(',', '.') ?? '')
      medias.mediaAltaLideranca = medias.mediaAltaLideranca + (isNaN(parse) ? 0 : parse)
    })
    tabela.forEach((e): void => {
      const parse = parseFloat(e.consolidado?.replace(',', '.') ?? '')
      medias.mediaConsolidado = medias.mediaConsolidado + (isNaN(parse) ? 0 : parse)
    })

    const mediasCalculado = [{
      mediaAltaLideranca: medias.mediaAltaLideranca / tabela.filter(r => r.altalideranca).length,
      mediaPares: medias.mediaPares / tabela.filter(r => r.pares).length,
      mediaAutoAval: medias.mediaAutoAval / tabela.filter(r => r.autoAvaliacao).length,
      mediaGestor: medias.mediaGestor / tabela.filter(r => r.gestor).length,
      mediaLiderados: medias.mediaLiderados / tabela.filter(r => r.liderados).length,
      mediaOutros: medias.mediaOutros / tabela.filter(r => r.outros).length,
      mediaConsolidado: medias.mediaConsolidado / tabela.filter(r => r.consolidado).length,
      mediaSemAuto: medias.mediaSemAuto / tabela.filter(r => r.mediaSemAuto).length
    }]
    return mediasCalculado
  }

  function calcularChunk(): number {
    let arrayToChunkLimit = 0
    competencias.forEach((e) => {
      if ((graficoHierarquia?.dados.length ?? 0) < 4) {
        if (e.nome.length < 22) {
          arrayToChunkLimit += 5
        } else if (e.nome.length < 44) {
          arrayToChunkLimit += 3
        } else {
          arrayToChunkLimit += 2
        }
      }
      e.questoes.forEach(() => {
        if ((graficoHierarquia?.dados.length ?? 0) >= 4) {
          if (e.nome.length < 22) {
            arrayToChunkLimit += 5
          } else if (e.nome.length < 44) {
            arrayToChunkLimit += 3
          } else {
            arrayToChunkLimit += 2
          }
        }
      })
      if ((graficoHierarquia?.dados.length ?? 0) >= 4) {
        if (e.nome.length < 22) {
          arrayToChunkLimit += 3.5
        } else if (e.nome.length < 44) {
          arrayToChunkLimit += 2
        } else {
          arrayToChunkLimit += 1
        }
      }
      e.questoes.forEach(() => {
        if ((graficoHierarquia?.dados.length ?? 0) >= 4) {
          if (e.nome.length < 22) {
            arrayToChunkLimit += 3.5
          } else if (e.nome.length < 44) {
            arrayToChunkLimit += 2
          } else {
            arrayToChunkLimit += 1
          }
        }
      })
    })
    if ((competencias?.length ?? 0) < arrayToChunkLimit * 0.1) {
      return 11
    } else if ((competencias?.length ?? 0) < arrayToChunkLimit * 0.2) {
      return 13
    } else if ((competencias?.length ?? 0) < arrayToChunkLimit * 0.3) {
      return 15
    } else {
      return 17
    }
  }

  function temColuna(tipo: number): boolean {
    return eixos.includes(tipo)
  }

  function GerarTabela(): iLinhaTabela[][] {
    const medias = handleMedia()
    const linhas: iLinhaTabela[] = []
    tabela.forEach((e) => {
      linhas.push(e)
      if (e.questoes.length > 1) {
        e.questoes.forEach((q, i2) => {
          linhas.push({
            idQuestao: '',
            competencia: `${e.competencia} ${(1 + i2)} >_<`,
            autoAvaliacao: q.autoAvaliacao,
            mediaSemAuto: q.mediaSemAuto,
            altalideranca: q.altalideranca,
            gestor: q.gestor,
            liderados: q.liderados,
            outros: q.outros,
            pares: q.pares,
            questoes: [],
            pergunta: q.pergunta
          })
        })
      }
    })

    linhas.push({
      idQuestao: '',
      competencia: 'Média geral',
      autoAvaliacao: medias[0].mediaAutoAval.toFixed(2),
      mediaSemAuto: medias[0].mediaSemAuto.toFixed(2),
      altalideranca: medias[0].mediaAltaLideranca.toFixed(2),
      gestor: medias[0].mediaGestor.toFixed(2),
      liderados: medias[0].mediaLiderados.toFixed(2),
      outros: medias[0].mediaOutros.toFixed(2),
      pares: medias[0].mediaPares.toFixed(2),
      questoes: []
    })
    return ArrayToChunks(linhas, calcularChunk())
  }

  function FormatarTabela(texto: string): string {
    const quebrado = texto.split(' ')
    const notNumber = isNaN(parseInt(quebrado[quebrado.length - 2]))
    if (texto.includes('Autodesenvolvimento') && (graficoHierarquia?.dados.length ?? 0) > 4) {
      return `Autodesenvolvi- mento ${notNumber ? '' : quebrado[quebrado.length - 2]}`
    }
    if (texto.includes('Comprometimento') && (graficoHierarquia?.dados.length ?? 0) > 5) {
      return `Comprometi- mento ${notNumber ? '' : quebrado[quebrado.length - 2]}`
    }
    return texto
  }

  function VerificarCorV2(eixo: string, nota: string, questoes?: iLinhaTabela[]): string {
    const dado = cores.find(e => e.eixo === eixo)

    if (questoes && questoes.length > 1 && dado !== null) {
      return dado?.notasNegativas.some(r => questoes.some(e => e[ParseEixo(eixo)] === r.toFixed(2))) ? '#F2994A' : dado?.notasPositivas.some(r => questoes.some(e => e[ParseEixo(eixo)] === r.toFixed(2))) ? '#00AA00' : 'black'
    }
    if (dado) {
      return dado.notasPositivas.some(r => r.toFixed(2) === nota?.replace(',', '.')) ? '#00AA00' : dado.notasNegativas.some(r => r.toFixed(2) === nota?.replace(',', '.')) ? '#F2994A' : 'black'
    }
    return 'black'
  }

  function ParseEixo(eixo: string): string {
    switch (eixo) {
      case 'gestor':
        return 'gestor'
      case 'par':
        return 'pares'
      case 'subordinado':
        return 'liderados'
      case 'outro':
        return 'outros'
      case 'autoavaliacao':
        return 'autoAvaliacao'
      default:
        return ''
    }
  }

  function VerificarCorRecomendacao(nota: string, index: number, questao?: string, questoes?: iLinhaTabela[]): string {
    const dado = cores.find(e => e.eixo === 'semAutoavaliacao')
    if (questao) {
      return recomendacoes.some((e: any) => (questao.includes(e.nome) && (nota.replace(',', '.') === e?.media?.toFixed(2))) || e.nome === questao) ? '#F2994A' : dado?.notasPositivas.some(r => questoes?.some(e => e.mediaSemAuto === r.toFixed(2)) || r.toFixed(2) === nota?.replace(',', '.')) ? '#00AA00' : 'black'
    }
    if (dado) {
      return dado.notasPositivas.some(r => r.toFixed(2) === nota?.replace(',', '.')) ? '#00AA00' : dado.recomendacoes.some(e => e === index) ? '#F2994A' : 'black'
    }
    return 'black'
  }

  function ReturnBox(childrenText: any, childrenImg: any[], color: string): any {
    return <View style={{ width: '130px', height: '118px', padding: '10px', color: '#fff', backgroundColor: color }}>
      <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
          <View style={{ fontSize: '14px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '7px' }}>
              {childrenText}
          </View>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px' }}>
            {childrenImg.map((img: any) => { return <Image src={img} style={{ width: '60px', objectFit: 'contain' }}/> })}
          </View>
      </View>
    </View>
  }

  function GetIconAvaliadores(eixo: number): any {
    let aval: any

    switch (eixo) {
      case 0:
        aval = AutoAval
        break
      case 1:
      case 6:
      case 7:
        aval = Gestor
        break
      case 2:
        aval = Pares
        break
      case 3:
        aval = Liderados
        break
      case 4:
        aval = Outros
        break
    }

    return <Image src={aval} style={{ width: '188px', objectFit: 'contain', marginHorizontal: '-30px' }}/>
  }

  function ReturnAgenda(activeCard: number): any {
    const cards = [
      '1. Diagnóstico comportamental',
      '2. Diagnóstico cognitivo',
      '3. Diagnóstico de percepções 360',
      '4. Visão Geral'
    ]

    return (
    <Page orientation={'landscape'} style={{ ...styles.DefaultPage, position: 'relative', paddingVertical: 0 }} size={{ height: 960, width: 540 }}>
      <Image
        src={FundoRoxo}
        style={{
          position: 'absolute',
          height: 540,
          width: 300,
          top: 0,
          right: 0
        }}
      />

      <Image
        src={Agenda1}
        style={{
          ...styles.rightImage,
          position: 'absolute',
          top: 44,
          right: 60
        }}
      />

      <Image
        src={BarraLateralAgenda}
        style={{
          height: 95,
          width: 95,
          position: 'absolute',
          top: 412,
          right: 46
        }}
      />

        <View style={{ display: 'flex', flexDirection: 'column', paddingTop: 32, paddingLeft: 32, gap: 6 }}>
          <Text style={styles.title}>Agenda</Text>
          <View style={{ height: '2px', width: '76px', backgroundColor: '#66046B' }}></View>
        </View>

        <View style={styles.leftColumn}>
          {cards.map((text, index) => {
            const isActive = activeCard === index
            return (
              <Text
                key={index}
                style={[
                  styles.card,
                  isActive ? styles.activeCard : styles.inactiveCard
                ]}
              >
                {text}
              </Text>
            )
          })}
        </View>

        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
          <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain' }} />
        </View>

      </Page>
    )
  }

  function obterTextoCognitivo(): string {
    if (cognitivo) {
      if (cognitivo > 260) {
        return 'Esperado que tenha muita facilidade nas novas tarefas, do ponto de vista cognitivo'
      } else if (cognitivo > 200) {
        return 'Deve ser bem sucedido em novas tarefas, do ponto de vista cognitivo'
      } else if (cognitivo > 160) {
        return 'Não deve ter grandes dificuldades em novas tarefas, do ponto de vista cognitivo'
      } else {
        return 'Pode ter dificuldades em novas tarefas, do ponto de vista cognitivo'
      }
    }

    return ''
  }

  function ReturnEixoPI(titulo: string, subtitulo: string, texto: string, color: string): any {
    return <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: 450, gap: '24px' }}>
      <Text style={{ fontFamily: 'Roboto', fontWeight: 'bold', fontSize: '18px', width: 90, textAlign: 'right', color: color }}>{titulo}</Text>
      <View style={{ color: color }}>
        <Svg color={color} fill={color} width="28" height="28" viewBox="0 0 6 4">
          <G fill={color}>
            <Path d="M0 0 L6 2 L0 4 Z" />
          </G>
        </Svg>
      </View>
      <View style={{ paddingVertical: '6px', display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '16px', width: 450 }}>
        <Text style={{ fontFamily: 'Roboto', fontWeight: 'bold', color: color }}>{subtitulo}</Text>
        <Text style={{ textAlign: 'justify' }}>{texto}</Text>
      </View>
    </View>
  }

  useEffect(() => {
    setIs90Graus(graficoHierarquia?.dados.length === 2)
  }, [graficoHierarquia])

  return (
    <Document>
      <Page style={{ position: 'relative' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ position: 'absolute', top: '0', left: '0' }}>
          <Image src={Gradient} style={{ height: 540, width: 960 }}/>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', gap: '24px', paddingTop: '84px', width: 960, alignItems: 'center', justifyContent: 'center' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
            <Image src={LogoAH} style={{ width: '254px', height: '254px' }}/>
            <View style={{ display: 'flex', flexDirection: 'column', gap: '24px', paddingTop: '50px' }}>
              <View style={{ display: 'flex', flexDirection: 'row', gap: '14px', position: 'relative', height: '132px' }}>
                <Image source={BarraLateralCapa} style={{ width: '100px', objectFit: 'contain', position: 'absolute', top: '-24px', right: '-48px', zIndex: '99' }}/>
                <Text style={styles.Title}>Assessment Integrado</Text>
              </View>
              <Text style={{ fontSize: '24px', color: '#fff' }}>{avaliado.nome.toUpperCase()}</Text>
            </View>
          </View>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '14px', width: 960, backgroundColor: '#fff', height: '92px', justifyContent: 'center' }}>
            <Image source={logoEmpresa} style={{ width: '210px', maxHeight: '84px', objectFit: 'contain' }}/>
          </View>
        </View>
      </Page>
      <Page style={styles.DefaultPage} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '12px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Jornada da liderança</Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>{nomeEmpresa}</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', gap: '0' }}>
            {ReturnBox(<><Text>Alinhamento da</Text><Text>Estratégia</Text></>, [ArcoAlvo], '#1961E0')}
            <View style={{ paddingTop: '34px' }}>{ReturnSeta('#1961E0')}</View>
            <View style={{ paddingVertical: '8px', paddingHorizontal: '10px', width: '158px', border: '1px dashed #BBBBBB', display: 'flex', flexDirection: 'column', gap: '6px', alignItems: 'center' }}>
              {ReturnBox(<Text>Diagnóstico</Text>, [Individuo, Grupo], '#66046B')}
              <Image src={coluna1} style={{ height: '258px', objectFit: 'contain' }}/>
            </View>
            <View style={{ paddingTop: '34px' }}>{ReturnSeta('#66046B')}</View>
            <View style={{ paddingVertical: '8px', paddingHorizontal: '10px', width: '158px', border: '1px dashed #BBBBBB', display: 'flex', flexDirection: 'column', gap: '6px', alignItems: 'center' }}>
              {ReturnBox(<Text>Desenvolvimento</Text>, [Engrenagem], '#1961E0')}
              <Image src={coluna2} style={{ height: '254px', objectFit: 'contain' }}/>
            </View>
            <View style={{ paddingTop: '34px' }}>{ReturnSeta('#1961E0')}</View>
            {ReturnBox(<><Text>Resultados</Text></>, [Resultados], '#66046B')}
        </View>
        <View>
          <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '-20px', bottom: '-4px' }}/>
        </View>
      </Page>
      {ReturnAgenda(0)}
      <Page style={styles.DefaultPage} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px', marginBottom: '12px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '20px', position: 'relative' }}>
            <View></View>
            <View style={{ display: 'flex', flexDirection: 'row', width: 896, gap: '12px', justifyContent: 'center', paddingTop: '26px' }}>
              <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>Definição da</Text>
              <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Persona</Text>
            </View>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '18px' }}>
          <View style={{ width: 230, display: 'flex', flexDirection: 'column', gap: 145, paddingTop: 56, fontSize: 20, fontFamily: 'Roboto', fontWeight: 'bold', alignItems: 'flex-end' }}>
            <Text style={{ textAlign: 'right' }}>Impulsos comportamentais</Text>
            <Text style={{ textAlign: 'right' }}>Conhecimentos e experiências</Text>
          </View>
          <Image src={Persona} style={{ width: 370, objectFit: 'contain' }}/>
          <View style={{ width: 230, display: 'flex', flexDirection: 'column', gap: 145, paddingTop: 80, fontSize: 20, fontFamily: 'Roboto', fontWeight: 'bold', alignItems: 'flex-start' }}>
            <Text style={{ textAlign: 'right' }}>Capacidade cognitiva</Text>
            <Text style={{ textAlign: 'right' }}>Valores</Text>
          </View>
        </View>
        <View></View>
      </Page>

      <Page orientation={'landscape'} style={{ display: 'flex', flexDirection: 'row', gap: 40, position: 'relative', paddingVertical: 0 }} size={{ height: 960, width: 540 }}>
        <Image
          src={FundoRoxo}
          style={{
            height: 540,
            width: 310
          }}
        />
        <View style={{ position: 'absolute', top: 78, left: 90, width: 320, height: 400, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#E3E3E3' }}>
          {returnCombinado()}
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', width: 580 }}>
          <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', paddingTop: 32, paddingHorizontal: 32, gap: 6 }}>
            <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
              <Text style={{ fontSize: '32px', color: '#000000', marginBottom: 8 }}>Perfil Comportamental –</Text>
              <Text style={{ fontSize: '32px', color: '#66046B', marginBottom: 8 }}>PI ®</Text>
            </View>
            <View style={{ height: '2px', width: '76px', backgroundColor: '#66046B' }}></View>
          </View>
          <View style={{ height: 440, display: 'flex', flexDirection: 'column', gap: '26px', alignItems: 'flex-end', paddingHorizontal: 32, paddingTop: '30px' }}>
            {ReturnEixoPI('Self', 'É', 'Impulsos e motivadores básicos. “Fazendo as coisas Naturalmente”.', '#1961E0')}
            {ReturnEixoPI('Conceito do Self', 'Percebe', 'Como um indivíduo percebe as exigências do ambiente quanto ao seu comportamento ou  necessidade de mudanças.', '#EB5757')}
            {ReturnEixoPI('Síntese', 'Está', 'Como o indivíduo se comporta no seu trabalho atual. Uma combinação do Self com o  Conceito do Self.', '#27AE60')}
          </View>
          <View>
            <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '-20px', bottom: '-4px' }}/>
          </View>
        </View>
      </Page>

      <Page style={styles.DefaultPage} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '12px', marginBottom: '6px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Relatório </Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>PI ® </Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>

    <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '18px', marginTop: '0px' }}>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '18px', width: '960px', alignItems: 'flex-start', justifyContent: 'flex-start' }}>

            <Text style={{ fontSize: '14px', fontFamily: 'Roboto', color: '#d12317', fontWeight: 700, textAlign: 'left', width: '800px' }}>Resumo</Text>
            <View style={{ height: '1px', width: '300px', backgroundColor: '#999999', marginBottom: '10px' }}></View>
            <Text style={{ fontSize: '11px', lineHeight: '1.4', fontFamily: 'Roboto', fontWeight: 'bold', textAlign: 'left', width: '800px' }}>{relatorioPi.resumo}</Text>
          </View>

        </View>

        <View>
          <Image src={LogoAHRodape} style={{ position: 'absolute', right: -26, bottom: -8, width: 42, objectFit: 'contain' }}/>
        </View>
      </Page>

{relatorioPi.comportamentos.length < 1200 && (<Page style={styles.DefaultPage} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '12px', marginBottom: '6px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Relatório </Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>PI ®</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>

    <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', alignContent: 'flex-start', justifyContent: 'space-between', gap: '18px', marginTop: '12px' }}>
          <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: '5px', width: '480px' }}>
            <Text style={{ fontSize: '14px', fontFamily: 'Roboto', fontWeight: 400, textAlign: 'left', width: '400px', color: '#d12317' }}>Estratégias de Gerenciamento:</Text>
            <View style={{ height: '1px', width: '300px', backgroundColor: '#999999', marginBottom: '10px' }}></View>
            <Text style={{ fontSize: '11px', fontFamily: 'Roboto', fontWeight: 'normal', textAlign: 'left', width: '400px' }}>{relatorioPi.estrategiasGerenciamento}</Text>
          </View>
          <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: '18px', width: '480px' }}>

            <View style={{ display: 'flex', flexDirection: 'column', gap: '5px', width: '480px' }}>
            <Text style={{ fontSize: '14px', fontFamily: 'Roboto', fontWeight: 400, textAlign: 'left', width: '400px', color: '#d12317' }}>Comportamentos mais fortes</Text>
            <View style={{ height: '1px', width: '300px', backgroundColor: '#999999', marginBottom: '10px' }}></View>
            <Text style={{ fontSize: '11px', fontFamily: 'Roboto', fontWeight: 'normal', textAlign: 'left', width: '400px' }}>{relatorioPi.comportamentos}</Text>
          </View>

          </View>

        </View>

        <View>
          <Image src={LogoAHRodape} style={{ position: 'absolute', right: -26, bottom: -8, width: 42, objectFit: 'contain' }}/>
        </View>
      </Page>)}

{relatorioPi.comportamentos.length >= 1200 && (<Page style={styles.DefaultPage} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '12px', marginBottom: '6px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Relatório </Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>PI ®</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>

    <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', alignContent: 'flex-start', justifyContent: 'space-between', gap: '18px', marginTop: '12px' }}>
          <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: '5px', width: '480px' }}>
            <Text style={{ fontSize: '14px', fontFamily: 'Roboto', fontWeight: 400, textAlign: 'left', width: '400px', color: '#d12317' }}>Estratégias de Gerenciamento:</Text>
            <View style={{ height: '1px', width: '300px', backgroundColor: '#999999', marginBottom: '10px' }}></View>
            <Text style={{ fontSize: '11px', fontFamily: 'Roboto', fontWeight: 'normal', textAlign: 'left', width: '400px' }}>{relatorioPi.estrategiasGerenciamento}</Text>
          </View>
          <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: '18px', width: '480px' }}>
          </View>
        </View>

        <View>
          <Image src={LogoAHRodape} style={{ position: 'absolute', right: -26, bottom: -8, width: 42, objectFit: 'contain' }}/>
        </View>
      </Page>
)}
    {relatorioPi.comportamentos.length >= 1200 && (<Page style={styles.DefaultPage} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '12px', marginBottom: '6px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Relatório </Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>PI ® </Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>

    <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '18px', marginTop: '0px' }}>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '18px', width: '960px', alignItems: 'flex-start', justifyContent: 'flex-start' }}>

            <Text style={{ fontSize: '14px', fontFamily: 'Roboto', color: '#d12317', fontWeight: 700, textAlign: 'left', width: '800px' }}>Comportamentos mais fortes</Text>
            <View style={{ height: '1px', width: '300px', backgroundColor: '#999999', marginBottom: '10px' }}></View>
            <Text style={{ fontSize: '11px', lineHeight: '1.4', fontFamily: 'Roboto', fontWeight: 'bold', textAlign: 'left', width: '800px' }}>{relatorioPi.comportamentos}</Text>
          </View>

        </View>

        <View>
          <Image src={LogoAHRodape} style={{ position: 'absolute', right: -26, bottom: -8, width: 42, objectFit: 'contain' }}/>
        </View>
      </Page>)}

      <Page style={styles.DefaultPage} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '12px', marginBottom: '6px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Relatório </Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>PI ®</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>

    <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '18px', marginTop: '12px' }}>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '5px', width: '480px' }}>
            <Text style={{ fontSize: '14px', fontFamily: 'Roboto', fontWeight: 400, textAlign: 'left', width: '400px', color: '#d12317' }}>Estilo de gerência</Text>
            <View style={{ height: '1px', width: '300px', backgroundColor: '#999999', marginBottom: '10px' }}></View>
            <Text style={{ fontSize: '11px', fontFamily: 'Roboto', fontWeight: 'normal', textAlign: 'left', width: '400px' }}>{relatorioPi.estiloGerencia}</Text>
          </View>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '18px', width: '480px' }}>

            <Text style={{ fontSize: '14px', fontFamily: 'Roboto', color: '#d12317', fontWeight: 700, textAlign: 'left', width: '400px' }}>Estilo de venda</Text>
            <View style={{ height: '1px', width: '300px', backgroundColor: '#999999', marginBottom: '10px' }}></View>
            <Text style={{ fontSize: '11px', fontFamily: 'Roboto', fontWeight: 'normal', textAlign: 'left', width: '400px' }}>{relatorioPi.estiloVenda}</Text>

          </View>

        </View>

        <View>
          <Image src={LogoAHRodape} style={{ position: 'absolute', right: -26, bottom: -8, width: 42, objectFit: 'contain' }}/>
        </View>
      </Page>
      <Page style={styles.DefaultPage} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '12px', marginBottom: '6px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Quadro desenvolvimento pessoal </Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>PI ®</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', gap: '12px' }}>
          {imagensQuadro.map(e => {
            return <Image src={e.base64} style={{ height: 430, width: 430 }}/>
          })}
        </View>
        <View>
          <Image src={LogoAHRodape} style={{ position: 'absolute', right: -26, bottom: -8, width: 42, objectFit: 'contain' }}/>
        </View>
      </Page>
      {ReturnAgenda(1)}
      <Page style={styles.DefaultPage} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '12px', marginBottom: '6px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Assessment Cognitivo</Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>PI ®</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '18px', marginTop: '12px' }}>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '18px', width: '480px' }}>
            <Text style={{ fontSize: '14px', fontFamily: 'Roboto', fontWeight: 700, textAlign: 'center', width: '400px' }}>Mede a velocidade e capacidade de aprendizagem, assimilação e aplicação de novas informações e conhecimentos.</Text>
            <Image src={AssessmentCognitivo} style={{ width: '480px', objectFit: 'contain' }}/>
          </View>
          <View style={{ height: '400px', width: '2px', backgroundColor: '#66046B' }}></View>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '18px', width: '400px' }}>
            <Text style={{ fontSize: '22px', color: '#66046B', marginBottom: '4px' }}>Resultado Cognitivo</Text>
            <View style={{ paddingLeft: '52px', display: 'flex', flexDirection: 'column', gap: '18px' }}>
              {cognitivo && cognitivo > 260 && <Image src={Nota1} style={{ height: '92px', objectFit: 'contain', position: 'absolute', left: '2px', top: '-15px' }}/>}
              {cognitivo && cognitivo > 200 && cognitivo <= 260 && <Image src={Nota2} style={{ height: '92px', objectFit: 'contain', position: 'absolute', left: '2px', top: '64px' }}/>}
              {cognitivo && cognitivo > 160 && cognitivo <= 200 && <Image src={Nota3} style={{ height: '92px', objectFit: 'contain', position: 'absolute', left: '2px', top: '138px' }}/>}
              {cognitivo && cognitivo <= 160 && <Image src={Nota4} style={{ height: '92px', objectFit: 'contain', position: 'absolute', left: '2px', top: '214px' }}/>}
              <Image src={Aderencia} style={{ height: '310px', objectFit: 'contain' }}/>
            </View>
          </View>
        </View>
        <View>
          <Image source={ContornoLateralRoxo} style={{ width: '65px', objectFit: 'contain', position: 'absolute', bottom: '-16px', left: '-31px', zIndex: '99' }}/>
          <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '-20px', bottom: '-4px' }}/>
        </View>
      </Page>
      {ReturnAgenda(2)}
      <Page style={{ ...styles.DefaultPage, position: 'relative' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px', marginBottom: '6px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Conceito da</Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>pesquisa de {tipoPesquisa}</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
          <View style={{ width: 380 }}>
            <Text style={{ fontSize: 20 }}>Apresentar a percepção das competências de cada colaborador pelos seus stakeholders em uma visão 360º</Text>
          </View>
        </View>
        <Image src={Conceito} style={{ height: 500, objectFit: 'contain', position: 'absolute', right: 100, bottom: 14, zIndex: -1 }}/>
        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', gap: '12px' }}>
        </View>
        <View>
          <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '-20px', bottom: '-4px' }}/>
        </View>
      </Page>
      <Page style={{ paddingVertical: 28, paddingHorizontal: 32, position: 'relative', display: 'flex', flexDirection: 'row', gap: '36px' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '32px', marginBottom: '6px', paddingTop: 12 }}>
          <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: -560, bottom: '-22px' }}/>
          <Image src={Arquitetura} style={{ width: 370, objectFit: 'contain' }}/>
          <View style={{ backgroundColor: '#1961E0', paddingVertical: 20, paddingHorizontal: 10, color: '#fff', fontWeight: 'bold', fontSize: 16, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: '12px', minWidth: 370, maxWidth: 370 }}>
            <Text>{escala.nome}</Text>
            <View style={{ position: 'absolute', right: -22 }}>
              {ReturnSeta('#fff')}
            </View>
          </View>
        </View>
        <View style={{ width: '1px', height: '225px', backgroundColor: '#66046B' }}></View>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px', marginBottom: '6px', width: 450 }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Arquitetura da</Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>Pesquisa</Text>
          </View>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative', marginTop: '12px' }}>
            <Text style={{ fontSize: '26px', color: '#CC42A2' }}>Critérios da avaliação</Text>
          </View>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '18px', color: '#000000' }}>As competências serão avaliadas através de um intervalo de notas que representa a frequência com que aquele comportamento é observado no AVALIADO, pelos seus avaliadores, no decorrer do desempenho de suas funções diariamente, sendo adotados os critérios abaixo:
            </Text>
          </View>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '18px', marginTop: '12px' }}>
            {escala.respostas.map((e, index) => {
              const isNaoAvalia = e.peso === -1
              const isAzul = index % 2 === 0
              const icon = isNaoAvalia
                ? ReturnX('#1961E0')
                : isAzul
                  ? ReturnCheck('#1961E0')
                  : ReturnCheck('#66046B')

              return (
                <View key={index} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
                  <View>{icon}</View>
                  <Text style={{ fontSize: '16px', color: '#000000' }}>
                    {e.resposta} {!isNaoAvalia && `(${e.peso})`}
                  </Text>
                </View>
              )
            })}
          </View>
        </View>
      </Page>
      <Page style={{ ...styles.DefaultPage, position: 'relative' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px', marginBottom: '-22px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Avaliadores</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '30px', height: 440, alignItems: 'center' }}>
          {eixos.filter(e => e !== 7).sort((a, b) => a - b).map(e => {
            return GetIconAvaliadores(e)
          })}
        </View>
        <View>
          <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '6px', bottom: '-4px' }}/>
        </View>
      </Page>
      <Page style={{ flexDirection: 'column', justifyContent: 'space-between', position: 'relative' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '10px', top: '12px' }}/>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px', paddingTop: 16, paddingHorizontal: 32, marginBottom: '4px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative', marginBottom: '-12px', alignItems: 'center' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Competências</Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>utilizadas</Text>
            <View style={{ marginLeft: '26px', border: '8px solid #66046B', fontSize: '18px', borderRadius: '50%', padding: '10px', fontFamily: 'Roboto', fontWeight: 'bold' }}>
              <Text>{competencias.length}</Text>
            </View>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '14px', paddingHorizontal: 32 }}>
          {ArrayToChunks(competencias, 5).map(comps => {
            return <View style={{ display: 'flex', flexDirection: 'row', justifyContent: comps.length === 5 ? 'space-between' : 'center', gap: comps.length === 5 ? '16px' : '42px' }}>
              {comps.map((r, i2) => {
                return (
                  <View key={i2} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                    <Image
                      src={r.icone.replace('Competencias-', 'Icones-SISTEMA-').replace('svg', 'png')}
                      style={{ width: 65, height: 65 }}
                    />
                    <Text style={{ fontSize: '12px', fontFamily: 'Roboto', fontWeight: 'bold', width: '110px', textAlign: 'center' }}>{r.nome}</Text>
                  </View>
                )
              }
              )}
            </View>
          })}
        </View>
        <View style={{ paddingVertical: 18, paddingHorizontal: 32, backgroundColor: '#CC42A2', color: '#ffffff', display: 'flex', flexDirection: 'row', gap: '20px', alignItems: 'center' }}>
          <View style={{ fontSize: '18px', fontFamily: 'Roboto', display: 'flex', flexDirection: 'row', gap: '6px' }}>
            <Text>O que é</Text>
            <Text style={{ fontWeight: 'bold' }}>competência?</Text>
          </View>
          <View style={{ height: '32px', width: '1px', backgroundColor: '#ffffff' }}></View>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <Text style={{ fontSize: '13px' }}>É o conjunto de habilidades, comportamentos, atitudes e conhecimentos interrelacionados, que uma pessoa precisa</Text>
            <Text style={{ fontSize: '13px' }}>para ser eficaz em sua posição.</Text>
          </View>
        </View>
      </Page>
      {ArrayToChunks(competencias.filter(e => e.questoes.length > 0), 3).map(comps => {
        return <Page style={{ ...styles.DefaultPage, position: 'relative' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px', marginBottom: '6px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative', marginBottom: '-6px', alignItems: 'center' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Competências</Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>utilizadas</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '30px' }}>
          {comps.map(e => {
            return <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px' }}>
              <View style={{ width: '120px', height: '100px' }}>
                <Image style={{ height: '100px', objectFit: 'contain' }} src={e.icone.replace('Competencias-', 'Icones-SISTEMA-').replace('svg', 'png')}/>
              </View>
              <View style={{ height: '100px', width: '2px', backgroundColor: '#66046B' }}></View>
              <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', fontSize: '14px', gap: '10px', width: '640px' }}>
                <Text style={{ fontSize: '12px', fontFamily: 'Roboto', color: '#66046B', fontWeight: 'bold', width: '300px', textAlign: 'left' }}>{e.nome}</Text>
                {e.questoes.map((q, i) => {
                  return <Text>{e.questoes.length > 1 ? `${i + 1} - ` : ''}{q.enunciado}</Text>
                })}
              </View>
            </View>
          })}
        </View>
        <View>
          <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '-20px', bottom: '-4px' }}/>
        </View>
      </Page>
      })}
      <Page style={{ ...styles.DefaultPage, position: 'relative' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative', marginBottom: '-6px', alignItems: 'center' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Notas por</Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>competências</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>
        <View style={{ position: 'relative', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
          <Image src={grafico1} style={{ height: 460, objectFit: 'contain', marginBottom: -40 }}/>
        </View>
        <View style={{ paddingVertical: 18, paddingHorizontal: 32, position: 'absolute', left: 20, bottom: 20, display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', fontSize: '14px', gap: '10px' }}>
            {ObterIcone2(4)}
            <Text>Competências de destaque</Text>
          </View>
          <View style={{ display: 'flex', flexDirection: 'row', fontSize: '14px', gap: '10px' }}>
            {ObterIcone2(1)}
            <Text>Competências para desenvolvimento</Text>
          </View>
        </View>
        <View>
          <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '-20px', bottom: '-4px' }}/>
        </View>
      </Page>
      <Page style={{ ...styles.DefaultPage, position: 'relative' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative', marginBottom: '-6px', alignItems: 'center' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Competências x</Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>Grupos de Avaliadores</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>
        <View style={{ position: 'relative', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
          <Image src={grafico2} style={{ height: 460, objectFit: 'contain', marginBottom: -40 }}/>
        </View>
        <View style={{ paddingVertical: 18, paddingHorizontal: 32, position: 'absolute', left: 20, bottom: 20, display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', fontSize: '14px', gap: '10px' }}>
            {ObterIcone2(4)}
            <Text>Competências de destaque</Text>
          </View>
          <View style={{ display: 'flex', flexDirection: 'row', fontSize: '14px', gap: '10px' }}>
            {ObterIcone2(1)}
            <Text>Competências para desenvolvimento</Text>
          </View>
        </View>
        <View>
          <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '-20px', bottom: '-4px' }}/>
        </View>
      </Page>
      {
        GerarTabela().map((chunck, index) => {
          return (
            <Page key={index} style={{ ...styles.DefaultPage, position: 'relative' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
              <View style={{ zIndex: 1 }}>
                <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px', marginBottom: '10px' }}>
                  <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative', marginBottom: '-6px', alignItems: 'center' }}>
                    <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Tabela geral das</Text>
                    <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>percepções</Text>
                  </View>
                  <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
                </View>
                <View style={{ marginTop: 10 }}>
                  <View style={styles.table}>
                    <View style={styles.tableRow}>
                      <View style={styles.tableHeaderCol}>
                        <Text style={styles.tableCell}>Competencia</Text>
                      </View>
                      {temColuna(0) && (
                        <View style={styles.tableHeaderCol}>
                          <Text style={styles.tableCell}>Autoavaliação</Text>
                        </View>
                      )}

                      {temColuna(1) && (
                        <View style={styles.tableHeaderCol}>
                          <Text style={styles.tableCell}>Gestor</Text>
                        </View>
                      )}

                      {temColuna(2) && (
                        <View style={styles.tableHeaderCol}>
                          <Text style={styles.tableCell}>Pares</Text>
                        </View>
                      )}

                      {temColuna(3) && (
                        <View style={styles.tableHeaderCol}>
                          <Text style={styles.tableCell}>Liderados</Text>
                        </View>
                      )}

                      {temColuna(4) && (
                        <View style={styles.tableHeaderCol}>
                          <Text style={styles.tableCell}>Outros</Text>
                        </View>
                      )}

                      {temColuna(6) && (
                        <View style={styles.tableHeaderCol}>
                          <Text style={styles.tableCell}>Alta liderança</Text>
                        </View>
                      )}

                      {(!Is90Graus) &&
                        <View style={styles.tableHeaderCol}>
                          <Text style={styles.tableCell}>Média do avaliado(a) sem autoavaliação</Text>
                        </View>
                      }
                    </View>

                    {
                      chunck.map((e, i) => {
                        return (
                          <View style={{
                            margin: 'auto',
                            flexDirection: 'row'
                          }}
                            key={i}
                          >
                            <View style={styles.tableCol}>
                              <Text style={e.competencia.includes('>_<') ? styles.tableCellQuestao : styles.tableCellCompetencia}>{FormatarTabela(e.competencia.replace('>_<', ''))}</Text>
                            </View>

                            {temColuna(0) && (e.competencia.includes('Média geral')
                              ? <View style={styles.tableCol}>
                                <Text style={{
                                  margin: 'auto',
                                  fontSize: 10
                                }}>{PropInvalida(e.autoAvaliacao) ? '-' : e.autoAvaliacao}</Text>
                              </View>
                              : <View style={styles.tableCol}>
                                <Text style={{
                                  margin: 'auto',
                                  fontSize: 10,
                                  color: VerificarCorV2('autoavaliacao', e.autoAvaliacao ?? '', e.questoes)
                                }}>{PropInvalida(e.autoAvaliacao) ? '-' : e.autoAvaliacao}</Text>
                              </View>)
                            }

                            {temColuna(1) && (e.competencia.includes('Média geral')
                              ? <View style={styles.tableCol}>
                                <Text style={{
                                  margin: 'auto',
                                  fontSize: 10
                                }}>{PropInvalida(e.gestor) ? '-' : e.gestor}</Text>
                              </View>
                              : <View style={styles.tableCol}>
                                <Text style={{
                                  margin: 'auto',
                                  fontSize: 10,
                                  color: VerificarCorV2('gestor', e.gestor ?? '', e.questoes)
                                }}>{PropInvalida(e.gestor) ? '-' : e.gestor}</Text>
                              </View>)
                            }

                            {temColuna(2) && (e.competencia.includes('Média geral')
                              ? <View style={styles.tableCol}>
                                <Text style={{
                                  margin: 'auto',
                                  fontSize: 10
                                }}>{PropInvalida(e.pares) ? '-' : e.pares}</Text>
                              </View>
                              : <View style={styles.tableCol}>
                                <Text style={{
                                  margin: 'auto',
                                  fontSize: 10,
                                  color: VerificarCorV2('par', e.pares ?? '', e.questoes)
                                }}>{PropInvalida(e.pares) ? '-' : e.pares}</Text>
                              </View>)
                            }

                            {temColuna(3) &&
                              (e.competencia.includes('Média geral')
                                ? <View style={styles.tableCol}>
                                  <Text style={{
                                    margin: 'auto',
                                    fontSize: 10
                                  }}>{PropInvalida(e.liderados) ? '-' : e.liderados}</Text>
                                </View>
                                : <View style={styles.tableCol}>
                                  <Text style={{
                                    margin: 'auto',
                                    fontSize: 10,
                                    color: VerificarCorV2('subordinado', e.liderados ?? '', e.questoes)
                                  }}>{PropInvalida(e.liderados) ? '-' : e.liderados}</Text>
                                </View>)
                            }

                            {temColuna(4) && (
                              e.competencia.includes('Média geral')
                                ? <View style={styles.tableCol}>
                                  <Text style={{
                                    margin: 'auto',
                                    fontSize: 10,
                                    padding: 1
                                  }}>{PropInvalida(e.outros) ? '-' : e.outros}</Text>
                                </View>
                                : <View style={styles.tableCol}>
                                  <Text style={{
                                    margin: 'auto',
                                    fontSize: 10,
                                    padding: 1,
                                    color: VerificarCorV2('outro', e.outros ?? '', e.questoes)
                                  }}>{PropInvalida(e.outros) ? '-' : e.outros}</Text>
                                </View>)
                            }

                            {temColuna(6) &&
                              (e.competencia.includes('Média geral')
                                ? <View style={styles.tableCol}>
                                  <Text style={{
                                    margin: 'auto',
                                    fontSize: 10,
                                    padding: 1
                                  }}>{PropInvalida(e.altalideranca) ? '-' : e.altalideranca}</Text>
                                </View>
                                : <View style={styles.tableCol}>
                                  <Text style={{
                                    margin: 'auto',
                                    fontSize: 10,
                                    padding: 1,
                                    color: VerificarCorV2('altaLideranca', e.altalideranca ?? '', e.questoes)
                                  }}>{PropInvalida(e.altalideranca) ? '-' : e.altalideranca}</Text>
                                </View>)
                            }

                            {
                              (!Is90Graus) && (e.competencia.includes('Média geral')
                                ? <View style={styles.tableCol}>
                                  <Text style={{
                                    margin: 'auto',
                                    fontSize: 10,
                                    padding: 1
                                  }}>{PropInvalida(e.mediaSemAuto) ? '-' : e.mediaSemAuto}</Text>
                                </View>
                                : <View style={styles.tableCol}>
                                  <Text style={{
                                    margin: 'auto',
                                    fontSize: 10,
                                    padding: 1,
                                    color: VerificarCorRecomendacao(e.mediaSemAuto ?? '', i + (index * 9), e.competencia, e.questoes)
                                  }}>{PropInvalida(e.mediaSemAuto) ? '-' : e.mediaSemAuto}</Text>
                                </View>
                              )
                            }
                          </View>
                        )
                      })
                    }

                  </View>
                </View>
              </View>
              <View>
                <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '-30px', bottom: '-14px' }}/>
              </View>
            </Page>
          )
        })
      }
      {ArrayToChunks(comentarios, 5).map(grupo => {
        return <Page style={{ ...styles.DefaultPage, position: 'relative', gap: '22px' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
          <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px' }}>
            <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative', marginBottom: '-6px', alignItems: 'center' }}>
              <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Comentários</Text>
            </View>
            <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
          </View>
          <View style={{ flex: 1 }}>
            <View style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '18px', justifyContent: 'center', backgroundColor: '#F0F0F0', gap: '8px' }}>
              {grupo.map(c => {
                return <View style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                  <Svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <Path d="M4 12L10 18L20 6" stroke="#E91E63" stroke-width="2" fill="none"/>
                  </Svg>
                  <Text style={{ width: '840px', fontSize: '12px' }}>{c}</Text>
                </View>
              })}
            </View>
          </View>
          <View>
            <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '-30px', bottom: '-14px' }}/>
          </View>
        </Page>
      })}
      {ReturnAgenda(3)}
      <Page orientation={'landscape'} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: 40, position: 'relative', paddingVertical: 0 }} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', width: 580 }}>
          <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', paddingTop: 32, paddingHorizontal: 32, gap: 6 }}>
            <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
              <Text style={{ fontSize: '32px', color: '#000000', marginBottom: 8 }}>Relatório Integrado –</Text>
              <Text style={{ fontSize: '32px', color: '#66046B', marginBottom: 8 }}>Visão Individual</Text>
            </View>
            <View style={{ height: '2px', width: '76px', backgroundColor: '#66046B' }}></View>
          </View>
          <View style={{ height: 440, display: 'flex', flexDirection: 'column', gap: '16px', alignItems: 'flex-start', paddingHorizontal: 32, paddingTop: '18px' }}>
            <View style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Text style={styles.TitleBlue}>Perfil comportamental</Text>
              <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center' }}>
                <Image src={getSeloInfoByNome(perfilPI.nomeSelo).url} style={{ width: '34px', height: '34px' }}/>
                <Text style={{ fontSize: '13px', width: 440 }}>{getSeloInfoByNome(perfilPI.nomeSelo).definicao}</Text>
              </View>
            </View>
            <View style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Text style={styles.TitleBlue}>Cognitivo</Text>
              <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center' }}>
                <Text style={{ fontSize: '13px' }}>•</Text>
                <Text style={{ fontSize: '13px', width: 440 }}>{obterTextoCognitivo()}</Text>
              </View>
            </View>
            <View style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Text style={styles.TitleBlue}>Pesquisa de percepção</Text>
              <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center' }}>
                <Text style={{ fontSize: '13px' }}>•</Text>
                <Text style={{ fontSize: '13px', width: 440 }}>Atingiu {mediaGeral} na média geral da avaliação dos stakeholders das {competencias.length} competências avaliadas.</Text>
              </View>
            </View>
            <View style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Text style={styles.TitleBlue}>Competências para desenvolvimento</Text>
              {recomendacoes.slice(0, 2).map(e => {
                return <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', alignItems: 'center' }}>
                  <View style={{ display: 'flex', flexDirection: 'column', gap: '6px', alignItems: 'center' }}>
                    <Image src={e.avatar.replace('Competencias-', 'Icones-SISTEMA-').replace('svg', 'png')} style={{ width: '64px', height: '64px' }}/>
                    <Text style={{ fontSize: '10px', textAlign: 'center', width: '92px' }}>{e.nome}</Text>
                  </View>
                  <View style={{ width: '1px', height: '62px', backgroundColor: '#66046B', marginRight: '12px' }}></View>
                  <Text style={{ fontSize: '13px', width: 380, textAlign: 'justify' }}>{e.pergunta}</Text>
                </View>
              })}
            </View>
          </View>
          <View>
          </View>
        </View>
        <Image
          src={FundoRoxo}
          style={{
            height: 540,
            width: 310
          }}
        />
        <View style={{ position: 'absolute', top: 78, right: 90, width: 320, height: 400, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#E3E3E3' }}>
          {returnCombinado()}
        </View>
      </Page>
      {acoes.filter(e => e.acao !== 'Desenvolvimento Geral').map(e => {
        return <Page style={{ ...styles.DefaultPage, position: 'relative' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
          <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '10px', top: '12px' }}/>
          <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px' }}>
            <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative', marginBottom: '-6px', alignItems: 'center' }}>
              <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Plano de Desenvolvimento</Text>
              <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>Individual</Text>
            </View>
            <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
          </View>
          <View style={{ display: 'flex', flexDirection: 'row', gap: 25, height: 440, alignItems: 'center' }}>
            <View style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Image src={LearningModel} style={{ width: 290, objectFit: 'contain' }}/>
              <Text style={{ fontSize: '11px', fontFamily: 'Roboto', width: 290, textAlign: 'center' }}>10% - Aprendizado formal, cursos estruturados, palestras, leituras...</Text>
              <Text style={{ fontSize: '11px', fontFamily: 'Roboto', width: 290, textAlign: 'center' }}>20% - Aprendizado com os outros como observação, pessoas que servem como modelo ou referência</Text>
              <Text style={{ fontSize: '11px', fontFamily: 'Roboto', width: 290, textAlign: 'center' }}>70% - Aprendizado através de atividades no dia a dia, vivenciar as experiências na prática, testar e se desafiar</Text>
            </View>
            <View style={{ width: '1px', height: 420, backgroundColor: '#66046B' }}></View>
            <View style={{ display: 'flex', flexDirection: 'column', gap: '16px', height: 440 }}>
              <View style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'row', gap: '10px', borderBottom: '1px solid #66046B', paddingHorizontal: 12, paddingBottom: 12 }}>
                {e.icone && <View style={{ marginLeft: '-12px' }}>
                  <Image src={e.icone?.replace('Competencias-', 'Icones-SISTEMA-').replace('svg', 'png')} style={{ width: 82, height: 82 }}/>
                </View>}
                <View style={{ display: 'flex', flexDirection: 'column' }}>
                  <Text style={{ width: 457, fontSize: 18, color: '#66046B', fontFamily: 'Roboto', marginBottom: '8px', paddingTop: '10px' }}>{e.acao}</Text>
                  {e.pergunta && <Text style={{ width: 457, fontSize: '14px', textAlign: 'justify' }}>{e.pergunta}</Text>}
                </View>
              </View>
              <View style={{ flexDirection: 'column', gap: '14px' }}>
                <View style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <Text style={{ fontSize: e.comoFazer.length > 800 ? '13px' : '15px', fontFamily: 'Roboto', fontWeight: 'bold' }}>O que fazer?</Text>
                  <Text style={{ fontSize: e.comoFazer.length > 800 ? '12px' : '14px', width: 570, textAlign: 'justify' }}>{e.oqueFazer}</Text>
                </View>
                <View style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <Text style={{ fontSize: e.comoFazer.length > 800 ? '13px' : '15px', fontFamily: 'Roboto', fontWeight: 'bold' }}>Como fazer?</Text>
                  <Text style={{ fontSize: e.comoFazer.length > 800 ? '12px' : '14px', width: 570, textAlign: 'justify' }}>{e.comoFazer}</Text>
                </View>
              </View>
            </View>
          </View>
          <View>
          </View>
        </Page>
      })}
    <Page orientation={'landscape'} style={{ ...styles.DefaultPage, position: 'relative', paddingVertical: 0 }} size={{ height: 960, width: 540 }}>
      <Image
        src={TextoFundoRoxo}
        style={{
          position: 'absolute',
          height: 540,
          width: 300,
          top: 0,
          right: 0
        }}
      />

      <Image
        src={LicaoDeCasa}
        style={{
          width: 340,
          position: 'absolute',
          top: 166,
          right: 44
        }}
      />

      <Image
        src={BarraLateralAgenda}
        style={{
          height: 95,
          width: 95,
          position: 'absolute',
          top: 378,
          right: 31
        }}
      />

        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px', paddingTop: 16 }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative', marginBottom: '-6px', alignItems: 'center' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Lição de</Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>casa</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>

        <View style={{ width: 740, paddingVertical: 24, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 22, zIndex: -1 }}>
          <Text style={{ fontSize: '16px', width: 480, fontFamily: 'Roboto', fontWeight: 'bold' }}>
            Pesquisar sobre cursos, conhecimento específicos para complementar o PDI, mantendo a <Text style={{ color: '#CC42A2' }}>metodologia de aprendizagem 70/20/10:</Text>
          </Text>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '13px', width: 480, paddingLeft: 24 }}>
            <Text><Text style={{ fontFamily: 'Roboto', fontWeight: 'bold' }}>• 70% do tempo</Text> do seu desenvolvimento deve ser dedicado para o <Text style={{ color: '#CC42A2', fontFamily: 'Roboto', fontWeight: 'bold' }}>aprendizado através de atividades no dia a dia</Text><Text style={{ fontFamily: 'Roboto', fontWeight: 'bold' }}>, vivenciar as experiências na prática</Text></Text>
            <Text><Text style={{ fontFamily: 'Roboto', fontWeight: 'bold' }}>• 20% do tempo</Text> do seu desenvolvimento deve ser dedicado para o <Text style={{ color: '#CC42A2', fontFamily: 'Roboto', fontWeight: 'bold' }}>aprendizado com os outros</Text> (observação, pessoas que servem como modelo, exemplo ou referência, mentoring)</Text>
            <Text><Text style={{ fontFamily: 'Roboto', fontWeight: 'bold' }}>• 10% do tempo</Text> do seu desenvolvimento deve ser dedicado para o <Text style={{ color: '#CC42A2', fontFamily: 'Roboto', fontWeight: 'bold' }}>aprendizado formal</Text>, como por exemplo cursos, palestras, leituras, workshops.</Text>
          </View>
          <Text style={{ fontSize: '16px', width: 480 }}>
            <Text style={{ color: '#CC42A2', fontFamily: 'Roboto', fontWeight: 'bold' }}>Validar com seu gestor imediato</Text> os pontos de desenvolvimento (comportamental e/ou técnico).
          </Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
          <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain' }} />
        </View>
      </Page>
      {
        (acoes && acoes.length > 0) && ArrayToChunks(acoes, 3).map((e, i) => {
          return (
              <Page
                orientation="landscape"
                style={{ ...styles.DefaultPage, position: 'relative', paddingVertical: 0 }}
                size={{ height: 960, width: 540 }}
              >
                <View style={{ flexDirection: 'column', alignItems: 'flex-start', paddingTop: 16 }}>
                  <Text style={{ fontSize: 32, color: '#66046B' }}>
                    Recomendações
                  </Text>
                  <View style={{ height: 1, width: 72, backgroundColor: '#66046B' }} />
                </View>
                  <View style={{ gap: 16, padding: 8 }}>
                    {e.map((acao, index) => (
                      <View
                        key={index}
                        wrap={false}
                        style={{
                          padding: 8,
                          gap: 8,
                          backgroundColor: '#F0F0F0'
                        }}
                      >
                        <View
                          style={{
                            flexDirection: 'row',
                            flexWrap: 'nowrap',
                            alignItems: 'center'
                          }}
                        >
                          <Image
                            style={{ objectFit: 'contain', height: 32 }}
                            src={
                              acao.icone?.replace('Competencias-', 'Icones-SISTEMA-').replace('svg', 'png') ??
                              urlDefault
                            }
                          />
                          <Text style={{ fontSize: 12 }}>
                            Ação {(acoes?.findIndex(a => a.acao === acao.acao) ?? 0) + 1}: {acao.acao}
                          </Text>
                        </View>

                        <View>
                          <Text style={{ fontSize: 11, fontFamily: 'Roboto', fontWeight: 'bold' }}>
                            O que fazer:
                          </Text>
                          <Text style={{ fontSize: 11 }}>{acao.oqueFazer}</Text>
                        </View>

                        <View>
                          <Text style={{ fontSize: 11, fontFamily: 'Roboto', fontWeight: 'bold' }}>
                            Como fazer:
                          </Text>
                          <Text style={{ fontSize: 11 }}>{acao.comoFazer}</Text>
                        </View>
                      </View>
                    ))}
                  </View>
              </Page>
          )
        }
        )
      }
      <Page orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <Image src={Contato} style={{ width: 960, height: 540 }}/>
        <View style={{ display: 'flex', flexDirection: 'column', position: 'absolute', fontFamily: 'Roboto', fontWeight: 'bold', left: 96, top: 372, gap: 17, fontSize: 16, color: '#66046B' }}>
          <Text>{responsavel.nome}</Text>
          <Text>{responsavel.email}</Text>
          <Text>{responsavel.numero}</Text>
          <Text>{responsavel.numeroEmpresa}</Text>
        </View>
      </Page>
    </Document>
  )
}
